import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { UserType } from './types.ts'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";

interface NewProps {
  user: UserType
}

export default function New({ user }: NewProps) {
  return (
    <>
      <Head title="New user" />

        <div className="space-y-6 p-8">
            <div className="flex items-center gap-4">
                <Link href="/admin/users">
                    <Button variant="ghost" size="sm">
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Back
                    </Button>
                </Link>
                <div>
                    <h1 className="text-3xl font-bold text-foreground">Add New User</h1>
                    <p className="text-muted-foreground">Create a new system user account</p>
                </div>
            </div>

        <Form
          user={user}
          method="post"
          action="/admin/users"
          submitText="Create User"
        />


      </div>
    </>
  )
}
